import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        padding: "3rem 1rem",
        maxWidth: "900px",
        margin: "0 auto",
        backgroundColor: "#FFFFFF",
        color: "#333",
        fontFamily: "sans-serif",
        lineHeight: "1.7",
      }}
    >
      <h1
        style={{
          color: "#4718AD",
          fontSize: "2.5rem",
          marginBottom: "1rem",
          textAlign: "center",
        }}
      >
        Política de Privacidade
      </h1>

      <p
        style={{
          textAlign: "center",
          color: "#666",
          marginBottom: "2rem",
        }}
      >
        Última atualização: 25 de junho de 2026
      </p>

      <section style={{ marginBottom: "2rem" }}>
        <p>
          A <strong>HallApp Ltda</strong>, responsável pela plataforma{" "}
          <strong>HallApp</strong>, respeita sua privacidade e está comprometida
          com a proteção dos dados pessoais de seus usuários, clientes e
          parceiros.
        </p>

        <p>
          Esta Política de Privacidade descreve como coletamos, utilizamos,
          armazenamos, compartilhamos e protegemos informações processadas em
          nossa plataforma, em conformidade com a legislação aplicável,
          incluindo a Lei Geral de Proteção de Dados (
          <strong>LGPD - Lei nº 13.709/2018</strong>).
        </p>
      </section>

      <Section
        title="1. Sobre o HallApp"
        items={[
          "Gestão de agendamentos online;",
          "Cadastro de clientes e profissionais;",
          "Comandas digitais e controle financeiro;",
          "Programas de fidelidade e recompensas;",
          "Relatórios gerenciais;",
          "Automação de comunicação com clientes;",
        ]}
      />

      <Section
        title="2. Dados que coletamos"
        items={[
          "Nome, telefone e e-mail dos usuários;",
          "Dados de cadastro da empresa contratante;",
          "Dados de profissionais vinculados à plataforma;",
          "Informações de clientes cadastrados;",
          "Histórico de agendamentos e serviços realizados;",
          "Dados financeiros relacionados à operação;",
          "Endereço IP, navegador, dispositivo e logs técnicos;",
          "Dados analíticos de uso da plataforma;",
        ]}
      />

      <Section
        title="3. Como utilizamos os dados"
        items={[
          "Executar os serviços contratados;",
          "Gerenciar agenda, atendimentos e histórico;",
          "Processar pagamentos e transações;",
          "Enviar notificações operacionais;",
          "Melhorar a experiência dos usuários;",
          "Garantir segurança da plataforma;",
          "Prevenir fraudes e acessos não autorizados;",
        ]}
      />

      <Section
        title="4. Integração com WhatsApp"
        items={[
          "Confirmações automáticas de agendamento;",
          "Lembretes de horários marcados;",
          "Cancelamentos e reagendamentos;",
          "Notificações relacionadas aos serviços contratados;",
          "Comunicação automatizada entre empresa e cliente final;",
        ]}
      >
        <p>
          O HallApp pode integrar-se à plataforma{" "}
          <strong>WhatsApp Business Platform</strong>, fornecida pela Meta,
          permitindo o envio automatizado de mensagens em nome da empresa
          contratante.
        </p>

        <p>
          Ao utilizar essa funcionalidade, dados como{" "}
          <strong>nome, número de telefone e conteúdo operacional</strong> podem
          ser processados pelos serviços da Meta exclusivamente para execução da
          comunicação solicitada.
        </p>

        <p>
          A empresa contratante é responsável por garantir que possui autorização
          ou base legal adequada para contatar seus clientes através do WhatsApp.
        </p>
      </Section>

      <Section
        title="5. Compartilhamento de informações"
        items={[
          "Meta Platforms (WhatsApp Business API);",
          "Serviços de hospedagem em nuvem;",
          "Serviços de banco de dados;",
          "Plataformas de envio de notificações;",
          "Gateways de pagamento;",
          "Autoridades legais quando exigido por lei;",
        ]}
      >
        <p>
          O HallApp não comercializa, vende ou compartilha dados pessoais para
          finalidades publicitárias não relacionadas à operação da plataforma.
        </p>
      </Section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={titleStyle}>6. Segurança das informações</h2>

        <p>
          Utilizamos medidas técnicas e organizacionais para proteger os dados
          processados em nossa plataforma.
        </p>

        <ul style={{ paddingLeft: "1.2rem", color: "#555" }}>
          <li>Criptografia de informações sensíveis;</li>
          <li>Controle interno de acesso;</li>
          <li>Backups automatizados;</li>
          <li>Monitoramento contínuo de infraestrutura;</li>
          <li>Proteção contra acessos não autorizados;</li>
          <li>Autenticação segura de usuários;</li>
        </ul>
      </section>

      <Section
        title="7. Armazenamento e retenção dos dados"
        items={[
          "Os dados permanecem armazenados enquanto houver relação contratual;",
          "Registros podem ser mantidos para cumprimento de obrigações legais;",
          "Dados podem ser removidos mediante solicitação quando permitido por lei;",
        ]}
      />

      <Section
        title="8. Direitos dos titulares"
        items={[
          "Solicitar acesso aos dados pessoais;",
          "Corrigir informações incorretas;",
          "Solicitar exclusão de dados quando aplicável;",
          "Revogar consentimentos fornecidos;",
          "Solicitar portabilidade quando aplicável;",
          "Solicitar informações sobre tratamento realizado;",
        ]}
      />

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={titleStyle}>9. Cookies e tecnologias similares</h2>

        <p>
          Podemos utilizar cookies e tecnologias semelhantes para melhorar a
          experiência do usuário, manter sessões autenticadas, gerar métricas e
          melhorar continuamente a plataforma.
        </p>
      </section>

      <section style={{ marginBottom: "2rem" }}>
        <h2 style={titleStyle}>10. Alterações nesta política</h2>

        <p>
          Esta Política de Privacidade poderá ser atualizada periodicamente para
          refletir mudanças legais, operacionais ou melhorias em nossos
          serviços.
        </p>
      </section>

      <section>
        <h2 style={titleStyle}>11. Contato</h2>

        <p>
          Em caso de dúvidas, solicitações ou questões relacionadas à privacidade
          e proteção de dados:
        </p>

        <p>
          <strong>HallApp Ltda</strong>
          <br />
          <strong>Email:</strong> suporte@hallapp.com.br
          <br />
          <strong>Website:</strong> https://hallapp.com.br
        </p>
      </section>

      <p
        style={{
          marginTop: "2rem",
          textAlign: "center",
          color: "#999",
        }}
      >
        Ao utilizar o HallApp, você concorda com os termos desta Política de
        Privacidade.
      </p>
    </div>
  );
};

const titleStyle = {
  color: "#4718AD",
  fontSize: "1.5rem",
  marginBottom: "1rem",
};

const Section = ({
  title,
  items,
  children,
}: {
  title: string;
  items?: string[];
  children?: React.ReactNode;
}) => (
  <section style={{ marginBottom: "2rem" }}>
    <h2 style={titleStyle}>{title}</h2>

    {items && (
      <ul style={{ paddingLeft: "1.2rem", color: "#555" }}>
        {items.map((item, idx) => (
          <li key={idx} style={{ marginBottom: "0.5rem" }}>
            {item}
          </li>
        ))}
      </ul>
    )}

    {children}
  </section>
);

export default PrivacyPolicy;